



import {
  createComponent,
  provide,
  inject,
  onMounted,
  computed
} from "@vue/composition-api";

import DisplayUIKey from "@/components/display-ui-key";
import displayUIStore from "@/stores/displayui";

import CompanyKey from "@/components/company-key";
import companyStore from "@/stores/company";
import CompanyRecruitmentKey from "@/components/company-recruitment-key";
import companyRecruitmentStore from "@/stores/companyRecruitment";
import CompanyCheckAmountKey from "@/components/company-check-amout-key";
import companyCheckAmountStore from "@/stores/companyCheckAmount";
import LoginKey from "@/components/login-key";
import loginStore from "@/stores/login";
import MenuKey from "@/components/menu-key";
import menuStore from "@/stores/menu";

export default createComponent({
  setup() {
    provide(DisplayUIKey, displayUIStore());
    provide(CompanyKey, companyStore());
    provide(CompanyRecruitmentKey, companyRecruitmentStore());
    provide(CompanyCheckAmountKey, companyCheckAmountStore());
    provide(LoginKey, loginStore());
    provide(MenuKey, menuStore());

    const displayui = inject(DisplayUIKey);
    const company = inject(CompanyKey);
    const companyRecruitment = inject(CompanyRecruitmentKey);
    const companyCheckAmount = inject(CompanyCheckAmountKey);
    const login = inject(LoginKey);
    const menu = inject(MenuKey);

    onMounted(() => {
      
    });

    return {
      displayui,
      company,
      companyRecruitment,
      companyCheckAmount,
      login,
      menu
    };
  },
  methods: {
    handler(e: any) {
      e.preventDefault();
      console.log("right-clicked", e.type);
    }
  }
});
